export const SYNTHETIC_DATA_DISABLED_MESSAGE =
  'Synthetic data feature is not active on this organization.';

export const SYNTHETIC_DATA_MANUAL_ONLY_MESSAGE =
  `${SYNTHETIC_DATA_DISABLED_MESSAGE} You can select only manual inputs.`;

export const TEST_EXECUTION_DISABLED_MESSAGE =
  'Test execution is not enabled for this organization. Contact your superadmin to enable this feature.';
